import styled from "styled-components";

const items = [
  {
    count: 50,
    suffix: "+",
    label: "Advanced & Fully Automated features",
  },
  {
    count: 50000,
    suffix: "+",
    duration: 2,
    label: "Satisfied Users Country wide",
  },
  {
    count: 5,
    duration: 10,
    suffix: " mins",
    label: "Maximum time taken from application to loan disbursement",
  },
];

export const Counter = () => {
  return (
    <Wrapper className="container x100" data-aos="fade-up">
      <GridWrapper className="secondaryBg r15 p30 white flexCenter patternGradient">
        {items.map((val, i) => (
          <Item data={val} index={i} key={i} />
        ))}
      </GridWrapper>
    </Wrapper>
  );
};

const Item = ({ data, index }) => {
  const { count, label, suffix } = data || {};
  return (
    <div className="textCenter flexCenter flexColumn">
      <div
        className="font30 bold mb10"
        data-aos="fade-up"
        data-aos-delay={index + 1 * 100}
        data-aos-duration="1500"
      >
        <div>
          {Number(count).toLocaleString()}
          {suffix}
        </div>
        {/* <CountUp
          start={0}
          end={label}
          duration={duration}
          delay={0}
          suffix={suffix}
        >
          {({ countUpRef }) => <span ref={countUpRef} />}
        </CountUp> */}
      </div>
      <div
        className="font12"
        style={{ maxWidth: "70%", color: "#ffffffcc" }}
        data-aos="fade-up"
        data-aos-delay={index + 2 * 100}
        data-aos-duration="1500"
      >
        {label}
      </div>
    </div>
  );
};

const Wrapper = styled.div`
  padding: 50px 20px;
  @media (max-width: 960px) {
    padding: 0 20px;
    padding-top: 20px;
  }
`;

const GridWrapper = styled.div`
  display: grid;
  gap: 20px;
  min-height: 180px;
  grid-template-columns: 1fr 1fr 1fr;

  @media (max-width: 960px) {
    gap: 40px;
    grid-template-columns: 1fr;
  }
`;
